import React from "react";
import { useLocation } from "react-router";
import { SignupFormValues } from "../types";

export const useSignupInitialValues = (): SignupFormValues => {
	const { search } = useLocation();
	return React.useMemo(() => {
		const params = new URLSearchParams(search);
		return {
			email: params.get("email") || "",
			name: params.get("name") || "",
			gReCaptchaToken: "",
		}
	}, [search]);
};
